import { Component, inject } from '@angular/core';
import { ButtonWarehouseComponent } from '../../components/returns-portal-components/button-warehouse/button-warehouse.component';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/translate/localstorage.service';
import { TranslateService } from 'src/app/core/services/translate/translate.service';
import { Location } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
	selector: 'app-page503',
	standalone: true,
	imports: [
		ButtonWarehouseComponent,
		TranslatePipe
	],
	templateUrl: './page503.component.html',
	styleUrl: './page503.component.scss'
})
export class Page503Component {
	public router = inject( Router );
	public localService = inject( LocalStorageService );
	public ts = inject( TranslateService );
	public location = inject( Location );

	goBack(): void {
		this.location.back();
	}
	tryToLogin(){
		this.router.navigateByUrl('auth/login')
	}
}
